// extracted by mini-css-extract-plugin
module.exports = {"root":"feedback_root__odyTL","radio_group":"feedback_radio_group__27vrO","feedback":"feedback_feedback__r-ccm","content":"feedback_content__1HN3G","last":"feedback_last__2R0cm"};